export const openNewTab = (url: string) => {
  window.open(url, '_blank')
}

export const getCurrentTime = () => {
  return new Date().getTime()
}

const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
  notation: 'compact',
})

export const formatMoney = (num: number | string | undefined) => {
  let numCast = Number(num)
  return moneyFormatter.format(numCast)
}
